type SortOrder = 'DESC' | 'ASC'
type SortingParam = string | number

/**
 *
 * @param extractorFn function that extracts the property to be compared in the ordering
 * @returns a function/closure on "order" that returns a sorter function
 * according to Array.prototype.sort() specs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 */
export const alphaNumericSorter =
  <TElement>(extractorFn: (el: TElement) => SortingParam) =>
  (order: SortOrder) =>
  (a: TElement, b: TElement) => {
    const first = extractorFn(a)
    const second = extractorFn(b)
    if (order === 'DESC') {
      if (first > second) {
        return -1
      }
      if (second > first) {
        return 1
      }
      return 0
    } else {
      if (first > second) {
        return 1
      }
      if (second > first) {
        return -1
      }
      return 0
    }
  }
